// extracted by mini-css-extract-plugin
export default {"root":"wcDkKrCD4E8U7dkZyQvY","panel":"DZeLzD8SNiomhIu6f6IJ"};